import gsap from 'gsap'

import {
  fadeRevealAnimation,
  getScrollTriggerOptions,
  linesRevealAnimation,
  mediaFadeRevealAnimation,
  type SharedAnimation
} from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const whereToFindUsRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const mediaEls = selector('[data-motion-media]')
  const titleEls = selector('[data-motion-title]')
  const textEls = selector('[data-motion-text]')
  const ctaEls = selector('[data-motion-cta]')

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse),
    delay
  })

  const mediaAnimations: SharedAnimation[] = []
  mediaEls.forEach((el: HTMLElement) => {
    const anim = mediaFadeRevealAnimation(el)
    mediaAnimations.push(anim)
    timeline.add(anim.timeline, 0)
  })

  const titleAnimations: SharedAnimation[] = []
  titleEls.forEach((el: HTMLElement) => {
    const anim = linesRevealAnimation(el, reverse)
    titleAnimations.push(anim)
    timeline.add(anim.timeline, 0.2)
  })

  const textAnimations: SharedAnimation[] = []
  textEls.forEach((el: HTMLElement) => {
    const anim = linesRevealAnimation(el, reverse)
    textAnimations.push(anim)
    timeline.add(anim.timeline, 0.3)
  })

  const ctaAnimations: SharedAnimation[] = []
  ctaEls.forEach((el: HTMLElement) => {
    const anim = fadeRevealAnimation(el)
    ctaAnimations.push(anim)
    timeline.add(anim.timeline, 0.5)
  })

  return () => {
    timeline.scrollTrigger?.kill()
    timeline.kill()

      ;[...mediaAnimations, ...titleAnimations, ...textAnimations, ...ctaAnimations].forEach(
        (anim) => anim.revert()
      )
  }
}
